// extracted by mini-css-extract-plugin
module.exports = {"post-tags":"tag_post-tags__RC017","tag-title":"tag_tag-title__wxz3O"};